'use client';

import { useLogoutConfirmStore } from '@/store/store';
import { useLogout } from '@/lib/auth/common/useSession';
import { LogoutConfirmationModal } from './LogoutConfirmationModal';

/**
 * The single instance of the logout confirmation flow — one shared store (see
 * useLogoutConfirmStore in store/store.ts for why), one useLogout() mutation, one
 * <LogoutConfirmationModal>. Mounted once in app/layout.tsx. MainNavigation and
 * AnnouncementBar just call useLogoutConfirmStore().open() from their own "Logout"
 * click handlers instead of each owning a full copy of this flow.
 */
export function LogoutConfirmationController() {
  const { isOpen, isLoggingOut, close, setLoggingOut } = useLogoutConfirmStore();
  const logoutMutation = useLogout();

  const handleConfirm = async () => {
    setLoggingOut(true);
    try {
      // useLogout ends the server session, clears the auth query cache, and hard-navigates
      // home (window.location.href — see useSession.ts for why a reload rather than a soft
      // router.replace()).
      await logoutMutation.mutateAsync();
      close();
    } catch {
      setLoggingOut(false);
    }
  };

  return (
    <LogoutConfirmationModal
      open={isOpen}
      onOpenChange={(open) => {
        if (!open) close();
      }}
      onConfirm={handleConfirm}
      loading={isLoggingOut}
    />
  );
}
